import { WorkingPage } from "../../../layouts/NotData";

const DomainDnsRecordsTab = () => {
  return (
    <>
      <WorkingPage />
    </>
  );
};

export default DomainDnsRecordsTab;
